<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="addCompanyHoliday(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Company Holiday':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Company Holiday Master
        </div>

        <div class="card-body p-1">
            <div class="row pb-2">
                <div class="col-md-1"><label>Year</label></div>
                <div class="col-md-2">
                    <select name="Year" (change)="HistoryFilterOnYear()" class="form-select"
                        [(ngModel)]="filter.HistoryYear" #Year="ngModel" required>
                        <option *ngFor="let Year of Years" [value]="Year">
                            {{Year}}
                        </option>
                    </select>
                </div>
            </div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Holiday Name</th>
                        <th style="width: 100px;">Date</th>
                        <th style="width: 5px;">Year</th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    (click)="addCompanyHoliday(TableData['ESS_CompanyHolidayMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td>{{TableData['HolidayName']}}</td>
                        <td style="width: 100px;">{{TableData['Date']}}</td>
                        <td style="width: 5px;">{{TableData['Year']}}</td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button  *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                    &nbsp; 
                    <button  *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Sample':'Loading...'}}
                    </button>
                    &nbsp; 
                    <label  *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)" accept=".xls,.xlsx">
                </div>
            </div>
        </div>
    </div>
</div>